(function () {
  /* multicolumn 描述滚动播放(Web Animations API 版):
     内容高度超过 max-height 的描述容器,把内容包进轨道层 track,
     用 track.animate 声明整段 translateY 动画——
     下行 → 底部停留 → 上行 → 顶部停留,无限往复;
     动画交给浏览器合成线程执行,整块文字平滑位移,滚动效果明显;
     鼠标悬停暂停便于阅读,悬停时滚轮可前后拖动播放进度;
     静态文件 + shopify:section:load 兜底:编辑器改设置局部刷新后重新初始化;
     ResizeObserver 监听容器/内容尺寸变化,重算距离与时长,
     自适应换行、字号、窗口缩放、设置修改 */
  function remPx() {
    /* 根字号由 JS 动态控制(rem 等比缩放),每次构建实时取,速度跟随窗口缩放 */
    var fs = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return isFinite(fs) && fs > 0 ? fs : 10;
  }

  function initBox(el) {
    var speed = parseFloat(el.getAttribute('data-text-scroll-speed'));
    console.log("测试的节点");
    if (!isFinite(speed) || speed <= 0) speed = 5;
    /* 顶/底停留时长由块设置传入(秒) */
    var pauseSec = parseFloat(el.getAttribute('data-text-scroll-pause'));
    var pause = isFinite(pauseSec) && pauseSec >= 0 ? pauseSec : 1.6;

    /* 内容包进轨道层:transform 作用于内容层,容器 max-height + overflow hidden 负责裁剪 */
    var track = document.createElement('div');
    track.setAttribute('data-ts-track', '');
    while (el.firstChild) track.appendChild(el.firstChild);
    el.appendChild(track);

    var anim = null;
    var dist = 0;

    function build() {
      if (!el.isConnected) {
        if (ro) ro.disconnect();
        if (anim) anim.cancel();
        return;
      }
      dist = el.scrollHeight - el.clientHeight;
      if (anim) {
        anim.cancel();
        anim = null;
      }
      /* 内容不超出最大高度:复位待机,尺寸变化恢复超出后由 ResizeObserver 重新构建 */
      if (dist <= 1) {
        track.style.transform = '';
        return;
      }
      var pxPerSec = speed * remPx();
      var T = dist / pxPerSec; /* 单程滚动秒数 */
      var total = 2 * (T + pause); /* 一个往复周期 */
      anim = track.animate(
        [
          { transform: 'translateY(0)', offset: 0 },
          { transform: 'translateY(' + -dist + 'px)', offset: T / total },
          { transform: 'translateY(' + -dist + 'px)', offset: (T + pause) / total },
          { transform: 'translateY(0)', offset: (2 * T + pause) / total },
          { transform: 'translateY(0)', offset: 1 }
        ],
        { duration: total * 1000, iterations: Infinity, easing: 'linear' }
      );
      build.pxPerSec = pxPerSec;
    }

    build();

    /* 悬停暂停:指针移入暂停动画便于阅读,移出继续;
       过滤触摸:tap 没有成对的 enter/leave 语义,避免移动端点一下后永久暂停 */
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'touch' && anim) anim.pause();
    });
    el.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'touch' && anim) anim.play();
    });
    /* 悬停时滚轮接管:把滚动量换算为动画进度,前后拖动播放位置 */
    el.addEventListener(
      'wheel',
      function (e) {
        if (dist <= 1 || !anim) return;
        e.preventDefault();
        anim.currentTime += (e.deltaY / build.pxPerSec) * 1000;
      },
      { passive: false }
    );

    /* 容器/内容尺寸变化(改设置/换行/字体加载/窗口缩放)重算距离与时长 */
    var ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(build);
      ro.observe(el);
      ro.observe(track);
    }
  }

  function initAll() {
    /* data-text-scroll-init 标记防重复初始化(shopify:section:load 可能多次触发) */
    var boxes = document.querySelectorAll('.rte[data-text-scroll-speed]:not([data-text-scroll-init])');
    Array.prototype.forEach.call(boxes, function (el) {
      el.setAttribute('data-text-scroll-init', '');
      initBox(el);
    });
  }

  /* readyState 判断:defer 加载时 DOM 已就绪立即初始化,
     极端情况下仍在解析则等 DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* 编辑器局部刷新兜底:设置修改后 section 重渲染,新容器由此重新初始化 */
  document.addEventListener('shopify:section:load', initAll);
})();
